/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */


import React, { PropTypes } from 'react';
import Link from '../Link';

const buttonPayStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px'
}
const PowrotDoListyEuslug = props => 
  <Link className={`btn btn-warning pull-${props.position}`} to={'/euslugi'} style={buttonPayStyle}>Powrót do listy eusług</Link>;

export default PowrotDoListyEuslug;


// WEBPACK FOOTER //
// src/components/PowrotDoListyEuslug/PowrotDoListyEuslug.js